import apiClient from './client';

// Get all users (admin only)
export const getAllUsers = async (skip = 0, limit = 100) => {
  try {
    const response = await apiClient.get(`/users?skip=${skip}&limit=${limit}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get user by ID
export const getUserById = async (userId) => {
  try {
    const response = await apiClient.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update user
export const updateUser = async (userId, userData) => {
  try {
    const response = await apiClient.put(`/users/${userId}/admin`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete user (admin only)
export const deleteUser = async (userId) => {
  try {
    const response = await apiClient.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create user
export const createUser = async (userData) => {
  try {
    const response = await apiClient.post('/users/create', userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reset user password (admin only)
export const resetUserPassword = async (userId, newPassword) => {
  try {
    const response = await apiClient.post(`/users/${userId}/reset-password`, { password: newPassword });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Change current user's password
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await apiClient.post('/users/me/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
